import React from "react";
import "../Styles/Navbar.css";
import { Link } from "react-router-dom";
import Logo from "../Assets/logo.png";

function Navbar() {
  return (
    <div className="navbar-section">
      <Link to="/" className="navbar-logo-container">
        <img src={Logo} alt="Workforce Nexus Logo" className="navbar-logo" />
      </Link>

      <ul className="navbar-items">
        <li>
          <a href="#about" className="navbar-links">
            About
          </a>
        </li>
        <li>
          <a href="#services" className="navbar-links">
            Services
          </a>
        </li>
        <li>
          <a href="#industries" className="navbar-links">
            Industries
          </a>
        </li>
        <li>
          <a href="#whychooseus" className="navbar-links">
            Why Choose Us
          </a>
        </li>
        <li>
          <a href="#contact" className="navbar-links">
            Contact
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;